






















































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";
import azureUpload from "../services/azure-upload";
import Axios from "axios";
import { BlobServiceClient } from "@azure/storage-blob";
//const uuidv1 = require("uuid/v1");

@Component
export default class LiteraryClub extends Vue {
  private display: any = [];
  private view = 0;
  private selected: any = {};
  private videoFile: Blob = new Blob();
  private apiLoading = false;

  private data = [
    {
      title: "Haya-Al-Fallah",
      text:
        "This is a competition of reciting the AZAAN in your voice. You can participate in this competition by sending us the video of the recitation of “AZAAN“. Following are the important points for your information and guidance.",
      judge: [
        "Tajheed : تجہید",
        "Awaaz : آواز",
        "Saans : سانس",
        "Tajweed : تجوید",
        "Layhun : لحن"
      ],
      rules: [
        "Dress-code is formal.",
        "The decision of the judge/s will be final.",
        "Get yourself registered uptill 13th of May."
      ],
      pic: "01",
      video: "https://www.youtube.com/embed/XQ7zekTnBqQ"
    },
    {
      title: "Hudal-lil-Muttaqeen (QIRAT Competition)",
      text:
        "This is the competition of reciting the holy verses of the Holy Quran in your voice. You can participate in this competition by sending us the video of your “QIRAT”. Followings are the important points for your information and guidance.",
      judge: [
        "Pronounciation : تلفظ",
        "Tajweed : تجوید",
        "Voice : آواز",
        "Saans : سانس",
        "Layhun : لحن"
      ],
      rules: [
        "Time duration for QIRAT must be 3 - 5 minutes.",
        "Negative marking shall be done, if time limit will not be followed.",
        "You may select any verses from the HOLY QURAN.",
        "No translation is required in or after recitation.",
        "Dress-code is formal.",
        "The decision of the judge/s will be final.",
        "Get yourself registered uptill 13th of May."
      ],
      pic: "02",
      video: "https://www.youtube.com/embed/KoanyEvZwcI"
    },
    {
      title: "Khair-ul-wara (HUSN-E-NAAT Competition)",
      text:
        "This is the competition of reciting the NAAT for our Holy Prophet (PBUH) in your voice. To participate in this competition, you need to send us the video of the recitation of NAAT. Followings are the important points for your information and guidance.",
      judge: [
        "Selection of kalam : کلام",
        "Pronunciation : تلفظ",
        "Presentation : پیشکش",
        "Rhythm : لحن"
      ],
      rules: [
        "The time for the recitation of NAAT must not exceed 3 minutes.",
        "Negative marking shall be done, if time limit will not be followed.",
        "You must select URDU Naatia kalam only.",
        "Other forms of kalam (such as Manqabat or Qaseeda etc) are not allowed.",
        "Dress-code is formal.",
        "The decision of the judge/s will be final.",
        "Get yourself registered uptill 13th of May."
      ],
      pic: "03",
      video: "https://www.youtube.com/embed/XpfgpSZrlT0"
    },
    {
      title: "ENGLISH SPEECH Competition",
      text:
        "This is the competition related to your presentation and vocal skills. You can participate in this competition by sending us the video of debate on the given topic. Followings are the important points for your information and guidance.",
      judge: ["Content", "Scale", "Proficiency", "Presentation Style"],
      rules: [
        "Time duration for English Speech competition is 3 to 5 minutes.",
        "Offensive wordings and remarks about important personage and passing controversial statements regarding religion, politics, and/or socio-cultural issues is strictly prohibited. Involvement to such impudence shall lead towards immediate disqualification.",
        "Use of indecent words and sentences shall lead towards immediate disqualification of the contestant.",
        "Paper reading will not be allowed. Those who do so will be disqualified.",
        "The decision of the judge/s will be final.",
        "Get yourself registered up till June 16, 2020."
      ],
      pic: "04",
      topic: "We are a crowd not a Nation",
      video: "https://www.youtube.com/embed/ux9OVFcFTZ4"
    },
    {
      title: "اردو تقریر مقابلہ",
      rules: [
        "مقابلہ میں اول، دوم اور سوئم آنیوالے طلباو طالبات کو انعامات سے نوازا جائے گا۔",
        "کاغذ یا پرچے سے پڑھنے کی اجازت نہ ہوگی",
        "منصفین (ججوں) کا فیصلہ حتمی اور نا قابل اپیل ہوگا۔",
        "مقابلہ میں اول، دوم اور سوئم آنیوالے طلباو طالبات کو",
        "رجسٹریشن کی آخری تاریخ 16 جون 2020"
      ],
      pic: "05",
      topic: " داغ اس عہدِ ستم کا دِل سے دہونا ہے ابھی",
      video: "https://www.youtube.com/embed/js8DJ6msW7M"
    },
    {
      title: "پنجابی ٹاکرا",
      rules: [
        "تقریر دا کُل ویلہ تن توں پنج منٹ ہووے گا-(3-5",
        "کاغذ پا پرچے توں ویکھ کے پڑھن دی اجازت نہیں ہووے گی",
        "سر پنچاں دا فیصلہ حتمی ہووے گا۔",
        "مقابلے وچ پیلی، دوجی تے تیجی پوزیشن تے آن والیاں نوں انعامات دتے جاون گے۔",
        "– بہترین بُلار نوں بابا بُلھے شاہ ٹرافی دتی جاوے گی۔",
        " رجسٹریشن دی آخری تاریخ 16 جون 2020"
      ],
      pic: "06",
      video: "https://www.youtube.com/embed/WyPcEcDJ7c4",
      topic: "ہن سکون اے"
    },
    {
      title: "National Song Competition",
      text:
        "This competition is related to your vocal and compositional skills. You can participate in this competition by sending us a patriotic and inspirational national song’s (Milli Nagma) video on the following topic.",
      judge: ["Content", "Scale", "Rhythm", "Presentation"],
      rules: [
        "Time duration for the national song (milli nagma) should not exceed 4 minutes.",
        "Negative marking will be done in case of exceeding the time limit.",
        "Use of indecent words and sentences shall lead towards immediate disqualification of the contestant.",
        "Dress code should be formal.",
        "National Language (Urdu) should be used for recording the national songs.",
        "The decision of the judge/s will be final.",
        "Get yourself registered up till June 27th, 2020."
      ],
      pic: "07",
      topic:
        "Khuda Kare Meri Arzay Pak Per Utray Wo Fasl e Gul Jissay Andesha e Zawal Na Ho",
      video: "https://www.youtube.com/embed/QxyD0Loq5fM"
    }
  ];

  getImgUrl(pet) {
    const images = require.context(
      "@/assets/images/literary/",
      false,
      /\.png$/
    );
    try {
      return images("./" + pet + ".png");
    } catch {}
  }

  comingSoon() {
    this.$bvModal.show("coming-soon");
  }

  viewDetails(ind) {
    window.scrollTo(0, 0);

    for (let i = 0; i < this.display.length; i++) {
      this.display[i] = false;
    }

    this.display[ind] = true;
    this.selected = this.data[ind];
    this.view = 1;
  }

  mounted() {
    this.comingSoon();
  }
}
